import { useQuery } from '@apollo/client/react';
import { useState } from 'react';

import { ClientCoachesDocument } from '../graphql/types';

const FIRST = 25;

const useClientCoachesQuery = (clientId: string | undefined) => {
  // "loading" will be true whenever the query hook is executed
  // but we want a loading state that is specific to when
  // `fetchMore` is executed, and this doesn't seem
  // to be something apollo client provides
  const [isFetchingMore, setIsFetchingMore] = useState(false);

  const { data, loading, error, fetchMore, refetch } = useQuery(
    ClientCoachesDocument,
    {
      fetchPolicy: 'cache-first',
      variables: {
        id: clientId!, // see skip
        input: {
          first: FIRST,
        },
      },
      skip: !clientId,
    },
  );

  const coaches = data?.client?.coaches.edges.map((edge) => edge.node);
  const coachCount = data?.client?.coaches?.count;

  const hasNextPage = data?.client?.coaches?.pageInfo?.hasNextPage;

  const loadMore = async () => {
    if (!hasNextPage || isFetchingMore) {
      return;
    }

    const endCursor = data?.client?.coaches?.pageInfo?.endCursor;

    setIsFetchingMore(true);

    try {
      await fetchMore({
        variables: {
          id: clientId,
          input: { first: FIRST, after: endCursor },
        },
      });
    } finally {
      setIsFetchingMore(false);
    }
  };

  return {
    data,
    loadMore,
    coachCount,
    coaches,
    fetch,
    refetch,
    error,
    loading,
    hasNextPage,
    isFetchingMore,
  };
};

export default useClientCoachesQuery;
